import React from 'react'
import Transactiondata from './table/Transactiondata'

export default function Transaction() {
  return (
    <div>
    <div className="flex flex-wrap justify-center">
    <div
      className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
      // "w-[calc(100vw_-_12rem)]"
    >
      {/* <Itemsdata /> */}
      <Transactiondata />
    </div>
  </div>
    
    
    </div>
  )
}
